import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/*' element={<AppRoutes />} />
            </Routes>
            <ToastContainer />
        </BrowserRouter>
    );
}

export default App;